import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { SnackBarService } from '@core/services/snack-bar.service';
import { authSessionExpiryNotifiedSignal } from '@core/state/auth-toast.state';
import { Endpoints } from '@core/constants/endpoints.constant';
import { extractBackendMessage } from '@core/utils/api-error.util';
import { SKIP_GLOBAL_ERROR_SNACKBAR } from '@core/tokens/http-context.tokens';

export const errorInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const _snackbar = inject(SnackBarService);

  const _isLoginValidate = request.url.includes(Endpoints.auth.loginValidate);
  const _skipSnackbar = request.context.get(SKIP_GLOBAL_ERROR_SNACKBAR);

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !_isLoginValidate) {
        if (!authSessionExpiryNotifiedSignal()) {
          authSessionExpiryNotifiedSignal.set(true);
          _snackbar.error({ title: 'زمان ورود شما به پایان رسید. لطفاً دوباره وارد شوید.' });
        }
        return throwError(() => error);
      }

      if (!_skipSnackbar) {
        _snackbar.error({ title: extractBackendMessage(error) });
      }

      return throwError(() => error);
    })
  );
};
